// extracted by mini-css-extract-plugin
export default {"wrapper":"media-upload-exports-MediaUploaderModal__wrapper--1vM7_"};